import Config from '../Config';

const apiService = {

	async request(action, params = {}) {
		let request = new URLSearchParams();
		request.append('action', action);
		request.append('username', localStorage.getItem('user'));
		request.append('password', localStorage.getItem('pass'));
		request.append('responsetype', 'json');
		for (let key of Object.keys(params))
			request.append(key, params[key]);
		
		let response = await fetch(`${Config.apiBase}`, {
			method: 'POST',
			body: request
		});
		let data = await response.json();
		if (!response.ok || data.result !== 'success')
			throw new Error('Request failed: ' + (data.message || response.statusText));

		return data;
	}

};

export default apiService;



// WEBPACK FOOTER //
// ./src/services/apiService.js